import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { VaccineTypePageStoryblok, VaccineTypeStoryblok } from "@storyblok-types"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import PageContainer from "@ui-library/layout/PageContainer"

interface VaccineTypePageProps {
  blok: BlokProps<VaccineTypePageStoryblok>["blok"]
  vaccine: VaccineTypeStoryblok | undefined
  /** Resolved from `relation_id` by the page — see getRelatedVaccines. */
  relatedVaccines?: VaccineTypeStoryblok[]
}

export const VaccineTypePage = ({ blok, vaccine, relatedVaccines }: VaccineTypePageProps) => {
  return (
    <PageContainer background={blok.background} extraHeight={false} {...withStoryblokEditable(blok)}>
      {blok.body.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
          vaccine={vaccine}
          relatedVaccines={relatedVaccines}
        />
      ))}
    </PageContainer>
  )
}

export default VaccineTypePage
